const ua = navigator.userAgent;
export const isWindows = /Windows/.test(ua);

if (isWindows) {
  document.documentElement.setAttribute('data-platform', 'windows');
}

/**
 * Returns a GPU-friendly transition string on Windows.
 * On Mac, returns 'all <timing>' as before.
 * Usage: transition: gpuTransition('0.2s ease')
 */
export const gpuTransition = (timing = '0.2s ease') =>
  isWindows
    ? `transform ${timing}, opacity ${timing}, border-color ${timing}, box-shadow ${timing}`
    : `all ${timing}`;
